import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { FormSelect, FormNumber, Selectize } from '~/components/FormControl';
import { COMPARED_OPTIONS } from '~/config/constants';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
function ConditionCheckDetail() {
    const { cardMetaData } = useFormTab();
    const { conditions } = cardMetaData;

    return (
        <>
            {!isEmpty(cardMetaData) && (
                <>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm="4"
                            name="conditionCheckDetail.condition1CheckEffects"
                            options={conditions || []}
                            tooltip="The first condition effect to check when card effect starts."
                        />
                        <FormSelect
                            name="conditionCheckDetail.playerDvCondition1Option"
                            options={COMPARED_OPTIONS || []}
                            sm={3}
                            tooltip="If the first condition checks for DV, this will select the comparative type."
                        />
                        <FormNumber
                            name="conditionCheckDetail.playerDvCondition1Value"
                            min={0}
                            max={12}
                            sm={3}
                            tooltip="If the first condition checks for DV, this will check player's DV against this value."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm="4"
                            name="conditionCheckDetail.condition2CheckEffects"
                            options={conditions || []}
                            tooltip="The second condition effect to check when card effect starts."
                        />
                        <FormSelect
                            name="conditionCheckDetail.playerDvCondition2Option"
                            options={COMPARED_OPTIONS || []}
                            sm={3}
                            tooltip="If the second condition checks for DV, this will select the comparative type."
                        />
                        <FormNumber
                            name="conditionCheckDetail.playerDvCondition2Value"
                            min={0}
                            max={12}
                            sm={3}
                            tooltip="If the second condition checks for DV, this will check player's DV against this value."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm="4"
                            name="conditionCheckDetail.condition3CheckEffects"
                            options={conditions || []}
                            tooltip="The third condition effect to check when card effect starts."
                        />
                        <FormSelect
                            name="conditionCheckDetail.playerDvCondition3Option"
                            options={COMPARED_OPTIONS || []}
                            sm={3}
                            tooltip="If the third condition checks for DV, this will select the comparative type."
                        />
                        <FormNumber
                            name="conditionCheckDetail.playerDvCondition3Value"
                            min={0}
                            max={12}
                            sm={3}
                            tooltip="If the third condition checks for DV, this will check player's DV against this value."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <FormSelect
                            name="conditionCheckDetail.opponentDvConditionOption"
                            options={COMPARED_OPTIONS || []}
                            sm={4}
                            tooltip="If the first condition checks for opponent's DV, this will select the comparative type."
                        />
                        <FormNumber
                            name="conditionCheckDetail.opponentDvConditionValue"
                            min={0}
                            max={12}
                            sm={3}
                            tooltip="If the first condition checks for opponent's DV, this will select the comparative type."
                        />
                    </Form.Row>
                </>
            )}
        </>
    );
}

export default ConditionCheckDetail;
